import { CircularProgress, MaudSectionHeader } from '@equip.health/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { PatientEvents } from '~/analytics/patientEvents';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import {
  PortalComponent,
  useComponentPortalContext,
} from '~/lib/contexts/ComponentPortalContext';
import useHasAuth0Permission from '~/lib/hooks/useHasAuth0Permission';

const TOP_LEVEL_ID = 'patient-table-action-bar';

const WRITE_PROVIDER_REASSIGNMENTS = 'write:provider-reassignments';

export interface PatientTableActionBarProps {
  headerText: string;
  isDataLoading: boolean;
  patientCount: number;
}

const PatientTableActionBar = ({
  headerText,
  isDataLoading,
  patientCount,
}: PatientTableActionBarProps) => {
  const { providerReassignments } = useFlags<LDFlags>();
  const hasWriteReassignments = useHasAuth0Permission(
    WRITE_PROVIDER_REASSIGNMENTS,
  );
  const { trackEvent } = useAnalytics();
  const { setComponentVisibility } = useComponentPortalContext();

  const showStartReassignment = providerReassignments && hasWriteReassignments;

  const handleStartReassignment = () => {
    trackEvent(PatientEvents.reassignmentStartClick, {
      source: AnalyticsSourceValues.PATIENT_LIST,
    });
    setComponentVisibility({
      component: PortalComponent.ADD_REASSIGNMENT_MODAL,
      isVisible: true,
    });
  };

  return (
    <MaudSectionHeader
      count={isDataLoading ? undefined : patientCount}
      id={TOP_LEVEL_ID}
      onAdd={showStartReassignment ? handleStartReassignment : undefined}
      onAddTitle="Start reassignment"
      title={headerText}
    >
      {isDataLoading && (
        <CircularProgress
          id={`${TOP_LEVEL_ID}__loading`}
          isIndeterminate
          size="20px"
        />
      )}
    </MaudSectionHeader>
  );
};

export default PatientTableActionBar;
